import Routes from "./routes";
import { StateProvider } from "store/StateProvider";
// import { ToastContainer } from "react-toastify";

// import "react-toastify/dist/ReactToastify.css";
import "./index.scss";
import { QueryClient, QueryClientProvider } from "react-query";
const queryClient = new QueryClient();
function App() {
  return (
    <StateProvider>
      <QueryClientProvider client={queryClient}>
        <Routes />
        {/* <ToastContainer /> */}
      </QueryClientProvider>
    </StateProvider>
  );
}
export default App;
